module.exports = __webpack_public_path__ + "static/img/充电桩banner最新.c120db0f.png";